__turbopack_context__.v({
  "ShowBannersSection": "ShowBannersSection-module__toJHYW__ShowBannersSection",
  "banner": "ShowBannersSection-module__toJHYW__banner",
  "col1": "ShowBannersSection-module__toJHYW__col1",
  "col2": "ShowBannersSection-module__toJHYW__col2",
  "contents": "ShowBannersSection-module__toJHYW__contents",
  "section": "ShowBannersSection-module__toJHYW__section",
  "smallWide": "ShowBannersSection-module__toJHYW__smallWide",
  "wide": "ShowBannersSection-module__toJHYW__wide",
});
